import React, { useState, useEffect } from 'react';

const initData = {
    heading: "Shaping the Digital Destiny of Businesses",
    content: "At MobiCloud, our commitment is to be the catalyst for your success, bringing unparalleled value to your business through innovative technology solutions.",
    headingSlug: "Transformative solutions for the digital era",
    ctaText: "Get Started",
    focusAreas: [
        {
            title: "Mobility",
            description: "Mobile App Development",
            icon: "fas fa-mobile-alt"
        },
        {
            title: "Cloud",
            description: "Cloud Services & Solutions",
            icon: "fas fa-cloud"
        },
        {
            title: "AI",
            description: "Artificial Intelligence & ML",
            icon: "fas fa-brain"
        }
    ]
};

const HeroSection = () => {
    const [data, setData] = useState(initData);

    useEffect(() => {
        setData(initData);
    }, []);

    return (
        <section id="home" className="section welcome-area gradient-bg overflow-hidden d-flex align-items-center">
            <div className="container">
                <div className="row align-items-center">
                    {/* Welcome Intro Start */}
                    <div className="col-12 col-lg-10 mx-auto text-center">
                        <div className="welcome-intro">
                            <h1 className="text-white mb-4">{data.heading}</h1>
                            <p className="text-white my-4 fs-5">{data.content}</p>
                            
                            {/* Focus Areas */}
                            <div className="focus-areas mb-5">
                                <div className="row justify-content-center">
                                    {data.focusAreas && data.focusAreas.map((area, idx) => (
                                        <div key={idx} className="col-12 col-md-4 mb-4">
                                            <div className="focus-area-card">
                                                <div className="focus-icon mb-3">
                                                    <i className={`${area.icon} fa-2x text-white-75`}></i>
                                                </div>
                                                <h3 className="text-white mb-2 fw-bold">{area.title}</h3>
                                                <p className="text-white-75 mb-0">{area.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            
                            {/* CTA Button */}
                            <div className="button-group store-buttons d-flex justify-content-center">
                                <a href="#contact" className="btn btn-primary btn-lg me-3">
                                    {data.ctaText}
                                </a>
                                <a href="#services" className="btn btn-primary btn-lg">
                                    Our Services
                                </a>
                            </div>
                            <span className="d-inline-block text-white-50 fw-3 font-italic mt-4">{data.headingSlug}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="shape-bottom">
                <svg viewBox="0 0 1920 310" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className="svg replaced-svg">
                    <title>MobiCloud Shape</title>
                    <desc>Created with Sketch</desc>
                    <defs />
                    <g id="MobiCloud-Landing-Page" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                        <g id="MobiCloud-v1.0" transform="translate(0.000000, -554.000000)" fill="#FFFFFF">
                            <path d="M-3,551 C186.257589,757.321118 319.044414,856.322454 395.360475,848.004007 C509.834566,835.526337 561.525143,796.329212 637.731734,765.961549 C713.938325,735.593886 816.980646,681.910577 1035.72208,733.065469 C1254.46351,784.220361 1511.54925,678.92359 1539.40808,662.398665 C1567.2669,645.87374 1660.9143,591.478574 1773.19378,597.641868 C1848.04677,601.75073 1901.75645,588.357675 1934.32284,557.462704 L1934.32284,863.183395 L-3,863.183395" id="MobiCloud-v1.0" />
                        </g>
                    </g>
                </svg>
            </div>
        </section>
    );
}

export default HeroSection; 